import { useCallback } from 'react';
import { useApplicationId } from '../../hooks/useApplicationId';
import { INTERVIEW_LANDING } from '../../shared/Routes';
import { useCallApi } from '../../hooks/useCallApi';
import { useConfirmPopup } from '../../hooks/useConfirmPopup';
import { useInfoPopup } from '../../hooks/useInfoPopUp';

export const useInterviewWizard = () => {
	const { navigateWithApplicationId } = useApplicationId();
	const { callApi } = useCallApi();
	const { confirmPopUpAction } = useConfirmPopup();
	const { infoPopUpAction } = useInfoPopup();

	const confirmAndSave = useCallback(
		<Resp,>(onConfirmSubmit: () => Promise<Resp>) =>
			confirmPopUpAction(
				'confirmSave',
				'areYouSureYouWantToSave',
				onConfirmSubmit,
				'saveAndContinue'
			),
		[confirmPopUpAction]
	);

	const confirmAndSubmit = useCallback(
		<Resp,>(onConfirmSubmit: () => Promise<Resp>) =>
			confirmPopUpAction(
				'confirmSubmit',
				'areYouSureYouWantToSubmit',
				onConfirmSubmit
			),
		[confirmPopUpAction]
	);

	const onConfirmCancel = useCallback(() => {
		navigateWithApplicationId(INTERVIEW_LANDING);
	}, [navigateWithApplicationId]);

	const onCancelClick = useCallback(() => {
		infoPopUpAction(
			'confirmCancel',
			'areYouSureYouWantToCancel',
			onConfirmCancel
		);
	}, [infoPopUpAction, onConfirmCancel]);

	return { confirmAndSave, confirmAndSubmit, onCancelClick, callApi };
};
